import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
// import { useSelector } from "react-redux";
const Footer = () => {
  const pageTitle = process.env.REACT_APP_APP_NAME;

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={6}>
              {new Date().getFullYear()} © {pageTitle}.
            </Col>
            <Col sm={6}></Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
